module.exports = __webpack_public_path__ + "static/media/Enable-auto-import-invoices-on-integrations.eaa71ab4.jpg";